module.exports = __webpack_public_path__ + "img/magento-security-services_small@2x.15048b05.webp";